import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H3.01v18H21V3h-3V1h-2zm3 18H5V8h14v11z"
}), 'InsertInvitationSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/InsertInvitationSharp.js
// module id = 4282
// module chunks = 2